module.exports = __webpack_public_path__ + "media/images/bitcoin-ed2a85627702576347e7ce84e0a2da47.svg";